import { render, staticRenderFns } from "./HuaxianCreditPolicy.vue?vue&type=template&id=002fd0d4&scoped=true&"
import script from "./HuaxianCreditPolicy.vue?vue&type=script&lang=js&"
export * from "./HuaxianCreditPolicy.vue?vue&type=script&lang=js&"
import style0 from "./HuaxianCreditPolicy.vue?vue&type=style&index=0&id=002fd0d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002fd0d4",
  null
  
)

export default component.exports